import actions from "./actions";

const initState = {
  roleList: [],
  menuItems: [],
  assertionID: "",
  error: "",
};

export default function roleReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_MENU_ITEMS:
      return {
        ...state,
        menuItems: action.data,
      };

    case actions.SET_ROLES:
      return {
        ...state,
        roleList: action.data,
      };

    default:
      return state;
  }
}
